import { ReactComponent as FlagIcon } from "./svg/lt-flag.svg";
import "../flag-icon.scss";

export const LTFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
